/** Spinning arc in the current text colour. Decorative: pair it with a visible or sr-only label. */
export function Spinner(props: { size?: number; class?: string }) {
  const s = () => props.size ?? 20;
  return (
    <svg
      class={`animate-spin shrink-0 ${props.class ?? ""}`}
      width={s()}
      height={s()}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-opacity="0.25" stroke-width="3" />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
      />
    </svg>
  );
}

/**
 * Small floating status ("Chargement des vélos…") over a map or camera view. role=status so
 * screen readers announce it; pointer-events off so it never blocks the map.
 */
export function LoadingPill(props: { label: string; class?: string }) {
  return (
    <div
      class={`pointer-events-none flex items-center gap-2 rounded-full bg-white/95 px-4 py-2 text-sm text-strong shadow ${props.class ?? ""}`}
      role="status"
    >
      <Spinner size={18} class="text-violet" />
      {props.label}
    </div>
  );
}

/** Whole-screen wait (boot, redirects, a screen whose data is not there yet). */
export function ScreenLoader(props: { label?: string }) {
  return (
    <div class="flex flex-1 flex-col items-center justify-center gap-3 p-6 text-text" role="status">
      <Spinner size={32} class="text-violet" />
      <span class="text-sm">{props.label ?? "Chargement…"}</span>
    </div>
  );
}
